import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function AdbIcon(props: IconProps) {
    return <Icon {...props} iconKey={"adb"}/>
}
